const parseNumber = (num) => {
  if (num === void 0) {
    return num;
  }
  if (typeof num === "number") {
    return num;
  }
  const parsedNumber = Number.parseInt(num, 10);
  return Number.isNaN(parsedNumber) ? void 0 : parsedNumber;
};
export default parseNumber;
